import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "modal-header" };
const _hoisted_2 = { class: "modal-title" };
const _hoisted_3 = { class: "modal-body" };
const _hoisted_4 = {
    key: 1,
    class: "modal-empty-state"
};
import { useActionModalStore } from '@/IsekaiRPG/modules/ui/uiStores';
import { onMounted, onUnmounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GlobalActionModal',
    setup(__props) {
        const actionModalStore = useActionModalStore();
        const handleClose = () => {
            actionModalStore.close();
        };
        const handleOverlayClick = () => {
            if (!actionModalStore.closeOnOverlay) {
                return;
            }
            // 点击空白处关闭
            handleClose();
        };
        // 键盘事件：Esc 关闭
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && actionModalStore.isOpen) {
                handleClose();
            }
        };
        onMounted(() => {
            window.addEventListener('keydown', handleKeyDown);
        });
        onUnmounted(() => {
            window.removeEventListener('keydown', handleKeyDown);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "action-modal-fade" }, {
                default: _withCtx(() => [
                    (_unref(actionModalStore).isOpen)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "global-action-modal-overlay",
                            onClick: _withModifiers(handleOverlayClick, ["self"])
                        }, [
                            _createVNode(_Transition, {
                                name: "action-modal-pop",
                                appear: ""
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(['action-modal-box', 'size-' + _unref(actionModalStore).size])
                                    }, [
                                        _createCommentVNode(" 华丽的外框背景流光装饰 "),
                                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-bg-glow" }, null, -1 /* CACHED */)),
                                        _createCommentVNode(" 华丽的外框装饰边角 "),
                                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "corner corner-tl" }, [
                                            _createElementVNode("div", { class: "corner-inner" })
                                        ], -1 /* CACHED */)),
                                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "corner corner-tr" }, [
                                            _createElementVNode("div", { class: "corner-inner" })
                                        ], -1 /* CACHED */)),
                                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "corner corner-bl" }, [
                                            _createElementVNode("div", { class: "corner-inner" })
                                        ], -1 /* CACHED */)),
                                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "corner corner-br" }, [
                                            _createElementVNode("div", { class: "corner-inner" })
                                        ], -1 /* CACHED */)),
                                        _createCommentVNode(" 标题栏 "),
                                        _createElementVNode("div", _hoisted_1, [
                                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-bg-gradient" }, null, -1 /* CACHED */)),
                                            _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(actionModalStore).title), 1 /* TEXT */),
                                            _createElementVNode("button", {
                                                class: "modal-close-btn",
                                                title: "关闭 (Esc)",
                                                onClick: handleClose
                                            }, [...(_cache[0] || (_cache[0] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        class: "close-icon",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            "stroke-width": "2",
                                                            d: "M6 18L18 6M6 6l12 12"
                                                        })
                                                    ], -1 /* CACHED */)
                                                ]))])
                                        ]),
                                        _createCommentVNode(" 动态内容区 "),
                                        _createElementVNode("div", _hoisted_3, [
                                            (_unref(actionModalStore).currentComponent)
                                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(actionModalStore).currentComponent), _mergeProps({ key: 0 }, _unref(actionModalStore).componentProps, { onClose: handleClose }), null, 16 /* FULL_PROPS */))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[2] || (_cache[2] = [
                                                        _createElementVNode("p", null, "加载中...", -1 /* CACHED */)
                                                    ]))]))
                                        ])
                                    ], 2 /* CLASS */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
